import { render, staticRenderFns } from "./SearchAdsCampaignsStatsChartContent.vue?vue&type=template&id=1973e16e"
import script from "./SearchAdsCampaignsStatsChartContent.vue?vue&type=script&lang=js"
export * from "./SearchAdsCampaignsStatsChartContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports